// src/components/Reports.js
import React from 'react';

const Reports = () => {
  return <div>Generate Reports</div>;
};

export default Reports;